import React from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import { RiDeleteBinLine } from 'react-icons/ri';

export interface Props {
	onDelete: () => void;
	children: JSX.Element | JSX.Element[];
	title: string;
}
const CustomContentWrapper = (props: Props) => {
	const { onDelete, children, title } = props;
	return (
		<>
			<Stack mt={2} direction="row" justifyContent="space-between" alignItems="center">
				<Typography variant="body2" sx={{ textTransform: 'uppercase', fontWeight: 400 }}>
					{title}
				</Typography>
				<IconButton onClick={onDelete}>
					<RiDeleteBinLine color="secondary" size={16} />
				</IconButton>
			</Stack>
			<Stack my={2} spacing={2} justifyContent="center">
				{children}
			</Stack>
		</>
	);
};

export default CustomContentWrapper;
